





















import { Component, Prop, Emit, Mixins } from "vue-property-decorator";

// Mixins
import {
  WidgetMixin,
  IdMixin,
  FieldMixin,
  GroupMixin,
  InputMixin,
  Event,
  Validator,
} from "./mixins";

import Phone from "@/components/Phone2.vue";
import { parsePhoneNumberFromString, PhoneNumber } from "libphonenumber-js";

@Component({
  components: {
    Phone,
  },
})
export default class WPhone extends Mixins(
  WidgetMixin,
  IdMixin,
  FieldMixin,
  GroupMixin,
  InputMixin
) {
  @Prop({ type: String })
  defaultCountryCode?: string[];

  created() {
    this.labelId = this.uniqueId("__W_PHONE_");
  }

  get number() {
    return parsePhoneNumberFromString(this.fieldValue || "");
  }

  @Emit("change")
  changeHandler(value: PhoneNumber | string | undefined) {
    this.fieldValue = (value === undefined || typeof value === "string")
      ? value : value.number
  }

  @Validator("phone", true)
  phoneValidator(value?: string) {
    if (!value) return true

    const number = parsePhoneNumberFromString(value);

    if (number) {
      return number.isValid();
    }

    return false;
  }

  @Validator("required")
  requiredValidator(value?: string) {
    return !!value;
  }
}
